module.exports = require("deep-extend");


//////////////////
// WEBPACK FOOTER
// external "deep-extend"
// module id = 280
// module chunks = 0